import OSelect from './OSelect'

export default OSelect
